import axios from "axios";
import { APP_API_URL } from "./constants";
import { useNavigate } from "react-router-dom";

const axiosInstance = axios.create({
  baseURL: APP_API_URL,
  withCredentials: true, // Include cookies with requests
});

// In-memory storage for the access token
// let accessToken: string | null = null;

// Function to set access token
// export const setAccessToken = (token: string | null) => {
//   accessToken = token;
// };

// Request interceptor to add the access token to headers
axiosInstance.interceptors.request.use(
  (config) => {
    // if (accessToken) {
    //   config.headers.Authorization = `Bearer ${accessToken}`;
    // }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // If token expired, refresh the token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const response = await axios.post(
          `${APP_API_URL}/auth/api/v1/auth/refresh-token`,
          {},
          { withCredentials: true },
        );
        // const newAccessToken = response.data.accessToken;

        // Update access token in memory and retry the original request
        // setAccessToken(newAccessToken);
        // originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers["Content-Type"] = "application/json";
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Redirect to login if refresh fails
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
